<div class="col-md-8 offset-md-2 col-sm-8 offset-sm-2">
  <div class="row row-cols-1 row-cols-lg-3 d-flex justify-content-center">
    <!--identibase+-->
    <div class="col my-5 text-center identibaseplus-price-card-wrapper">
      <app-price-card
        [viewOnly]="false"
        [showShortDescription]="false"
        [showInfoLine]="false"
        [showFeatures]="true"
        [buttonLabel]="identibasePlusButtonLabel"
        [hidePrices]="true"
        [showButton]="(buyButtonVisible || (!buyButtonVisible && !basicPlusHighlighted))"
        [disabled]="buyButtonDisabled && !!findHighlighted"
        (onSelect)="
          onIdentitableButtonClicked(IdentitableButtonEnum.IdentibasePlusButton)
        "
        [highlighted]="basicPlusHighlighted"
        imageUri="/assets/images/pricingTable/identibasePlus.svg"
        planTitle="identibase+"
        planLongSubtitle="For less than 3p per day, activate your pet’s Digital ID with:"
        [hidePlusFromSubtitle]="true"
        [features]="getFeaturesFor(planFeatureService.identiBasePlusPlanName)"
        yearlyPrice="£15"
        description="Get your missing pet home more quickly by activating your pet’s
      Digital ID. And, with identibase+, keep the Digital ID up to date with
      unlimited changes to your details."
        [showBestSeller]="false"
      >
      </app-price-card>
    </div>

    <!--Identialert-->
    <div class="col mb-5 text-center">
      <app-price-card
        [viewOnly]="false"
        [showShortDescription]="false"
        [showInfoLine]="false"
        [showFeatures]="true"
        [buttonLabel]="identialertButtonLabel"
        [hidePrices]="true"
        [showButton]="(buyButtonVisible || (!buyButtonVisible && !alertHighlighted))"
        [disabled]="buyButtonDisabled && !!findHighlighted"
        (onSelect)="
          onIdentitableButtonClicked(IdentitableButtonEnum.IdentialertButton)
        "
        [highlighted]="alertHighlighted"
        [showBestSeller]="false"
        [features]="getFeaturesFor(planFeatureService.identiAlertPlanName)"
        imageUri="/assets/images/pricingTable/identialert.svg"
        planTitle="identialert"
        planShortSubtitle="Everything from identibase+"
        planLongSubtitle="For less than 9p per day, get everything from identibase+"
        yearlyPrice="£36"
        monthlyPrice="£4.99"
        priceNote="(12 month contract)"
        description="The fastest way to find your missing pet. A 24/7 network of pet finders - with alerts sent to every vet, warden, rescue centre, police and identibase customers in your area."
      >
      </app-price-card>
    </div>

    <!--Identifind-->
    <div class="col mb-4 text-center">
      <app-price-card
        [viewOnly]="false"
        [showShortDescription]="false"
        [showInfoLine]="false"
        [showFeatures]="true"
        [buttonLabel]="identifindButtonLabel"
        [showButton]="(buyButtonVisible || (!buyButtonVisible && !findHighlighted))"
        [hidePrices]="true"
        [disabled]="buyButtonDisabled && !!findHighlighted"
        (onSelect)="
          onIdentitableButtonClicked(IdentitableButtonEnum.IdentifindButton)
        "
        [highlighted]="findHighlighted"
        [features]="getFeaturesFor(planFeatureService.identiFindPlanName)"
        imageUri="/assets/images/pricingTable/identifind.svg"
        planTitle="identifind"
        planShortSubtitle="Everything from identialert"
        planLongSubtitle="Get everything from identialert"
        yearlyPrice="£36"
        [oneOffPrice]="'+£129 one-off payment'"
        description="Complete peace of mind that you’ll never lose your pet again, with GPS tracking. View your pet’s live location and monitor their activity."
        [showBestSeller]="false"
      >
      </app-price-card>
    </div>
  </div>
</div>
